// Action Types
export const SET_SSO_DATA = "SET_SSO_DATA";
export const CLEAR_SSO_DATA = "CLEAR_SSO_DATA";

// Action Creator to store SSO user data
export const setSSOData = (ssoData) => {
  return {
    type: SET_SSO_DATA,
    payload: ssoData,  // Store all user details
  };
};

// Action Creator to clear SSO data (if needed)
export const clearSSOData = () => {
  return {
    type: CLEAR_SSO_DATA,
  };
};

// Initial state for SSO
const initialState = {
  isSSO: false,  // Default is non-SSO user
  ssoUserData: {},  // Store full SSO user details
};

// Reducer to handle SSO state
const ssoReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SSO_DATA:
      return {
        ...state,
        isSSO: !!action.payload, // true only if payload is valid
        ssoUserData: action.payload || {}, // fallback to {}
      };
    case CLEAR_SSO_DATA:
      return {
        ...state,
        isSSO: false,
        ssoUserData: {}, // Reset SSO user data
      };
    default:
      return state;
  }
};

export default ssoReducer;
